import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';

import { ClienteAnaliseMercadoFormComponent } from '../cliente-analise-mercado-form.component';
import { ClienteAnaliseMercadoPerspectiva } from '../../perspectivas';
import { ClienteAnaliseMercadoFormModal } from './cliente-analise-mercado-form.modal';

@Component({
    selector: 'sgt-cliente-analise-mercado-form-modal',
    templateUrl: './cliente-analise-mercado-form-modal.component.html',
    styleUrls: ['./cliente-analise-mercado-form-modal.component.less'],
    providers: [
        ClienteAnaliseMercadoFormModal
    ]
})
export class ClienteAnaliseMercadoFormModalComponent implements OnInit {
    elModal: any;

    @ViewChild('form') form: ClienteAnaliseMercadoFormComponent;
    @ViewChild('btnSave') btnSave: ElementRef;
    @Output() afterClose = new EventEmitter<void>();

    constructor(private el: ElementRef,
                public modal: ClienteAnaliseMercadoFormModal) { }

    ngOnInit() {
        this.create();
    }

    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                this.form?.load(this.modal.data.idCliente, this.modal.data.ano, this.modal.data.perspectiva);
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.modal.close();
                this.afterClose.emit();
                e.stopPropagation();
            });
    }

    /** Abre o modal */
    open(idCliente: number, ano: number, perspectiva: ClienteAnaliseMercadoPerspectiva) {
        this.modal.open(idCliente, ano, perspectiva);
        setTimeout(() => this.elModal.modal({keyboard: false, backdrop: 'static'}), 0);
    }

    /** Fecha o modal */
    close() {
        this.elModal.modal('hide');
    }
}
